// src/frontend/js/modern/shared/variation-handler.js
import { validators } from './validators.js';

export function handleVariationShown(data, moduleType, store, ui) {
	const productId = data.product_id;
	const variationId = data.variation_id;
	if (!productId || !variationId) return;
	if (moduleType === 'multiList') {
		return;
	}

	const prefix = moduleType === 'wishlist' ? 'wlfmc-add-to-wishlist' : 'wlfmc-add-to-waitlist';
	const targets = document.querySelectorAll(`.${prefix} [data-parent-product-id="${productId}"]`);
	if (!targets.length) return;

	if (moduleType === 'wishlist') {
		const enableOutofstock = targets[0]?.closest(`.${prefix}`)?.dataset.enableOutofstock;
		if (!enableOutofstock && !data.is_in_stock) {
			targets.forEach(el => el.closest(`.${prefix}`)?.classList.add('hide'));
		} else {
			targets.forEach(el => el.closest(`.${prefix}`)?.classList.remove('hide'));
		}
	} else {
		targets.forEach(el => {
			const container = el.closest(`.${prefix}`);
			if (container) container.classList.remove('hide');
		});
	}

	const popupId = targets[0]?.closest(`.${prefix}`)?.dataset.popupId;
	if (popupId && moduleType === 'wishlist') {
		const popup = document.getElementById(popupId);
		if (popup) {
			const productTitle = popup.dataset.productTitle || '';
			const originalPrice = popup.querySelector('.wlfmc-parent-product-price')?.innerHTML || '';
			ui.updatePopupContent(popup, data, productTitle, originalPrice);
		}
	}

	targets.forEach(el => {
		const container = el.closest(`.${prefix}`);
		if (!container) return;
		el.dataset.parentProductId = productId;
		el.dataset.productId = variationId;
		// FIX: Use \d+ to only replace the numeric ID class
		container.className = container.className.replace(new RegExp(`${prefix}-\\d+`, 'g'), `${prefix}-${variationId}`);
		container.classList.remove('exists');
		if (moduleType === 'wishlist') {
			const addLink = container.querySelector('.wlfmc-addtowishlist a');
			if (addLink) addLink.href = container.dataset.addUrl?.replace('#product_id', variationId) || '#';
			const removeLink = container.querySelector('.wlfmc-removefromwishlist a');
			if (removeLink) removeLink.href = container.dataset.removeUrl?.replace('#product_id', variationId) || '#';
		}
		const items = store.items.get();
		const found = items.find(item => String(item.product_id) === String(variationId));
		if (found) {
			container.classList.add('exists');
			const deleteBtn = container.querySelector('.wlfmc_delete_item');
			if (deleteBtn) {
				deleteBtn.dataset.wishlistId = found.wishlist_id;
				deleteBtn.dataset.itemId = found.item_id;
			}
		}
		if (productId && moduleType === 'waitlist') {
			const trigger = container.querySelector('.wlfmc-popup-trigger');
			if (trigger) trigger.classList.remove('wlfmc-disabled');
		}
	});
}

export function handleVariationReset(productId, moduleType, store, ui) {
	if (!productId) return;
	if (moduleType === 'multiList') {
		return;
	}

	const prefix = moduleType === 'wishlist' ? 'wlfmc-add-to-wishlist' : 'wlfmc-add-to-waitlist';
	const targets = document.querySelectorAll(`.${prefix} [data-parent-product-id="${productId}"]`);
	if (!targets.length) return;

	targets.forEach(el => {
		const container = el.closest(`.${prefix}`);
		if (!container) return;
		container.classList.remove('hide');
		el.dataset.parentProductId = productId;
		el.dataset.productId = productId;
		// FIX: Use \d+ to only replace the numeric ID class
		container.className = container.className.replace(new RegExp(`${prefix}-\\d+`, 'g'), `${prefix}-${productId}`);
		container.classList.remove('exists');
		if (moduleType === 'wishlist') {
			const addLink = container.querySelector('.wlfmc-addtowishlist a');
			if (addLink) addLink.href = container.dataset.addUrl?.replace('#product_id', productId) || '#';
			const removeLink = container.querySelector('.wlfmc-removefromwishlist a');
			if (removeLink) removeLink.href = container.dataset.removeUrl?.replace('#product_id', productId) || '#';
		}
		const items = store.items.get();
		const found = items.find(item => String(item.product_id) === String(productId));
		if (found) {
			container.classList.add('exists');
			const deleteBtn = container.querySelector('.wlfmc_delete_item');
			if (deleteBtn) {
				deleteBtn.dataset.wishlistId = found.wishlist_id;
				deleteBtn.dataset.itemId = found.item_id;
			}
		}
		if (moduleType === 'waitlist') {
			const l10n = window.wlfmc_l10n || {};
			if (validators.isTrue(l10n.waitlist_required_product_variation)) {
				const trigger = container.querySelector('.wlfmc-popup-trigger');
				if (trigger) trigger.classList.add('wlfmc-disabled');
			}
		}
		const popupId = container?.dataset.popupId;
		if (popupId && moduleType === 'wishlist') {
			const popup = document.getElementById(popupId);
			if (popup) {
				const productTitle = popup.dataset.productTitle || '';
				const originalPrice = popup.querySelector('.wlfmc-parent-product-price')?.innerHTML || '';
				const desc = window.wlfmc_l10n?.labels?.popup_content;
				const title = window.wlfmc_l10n?.labels?.popup_title;
				const img = popup.querySelector('.wlfmc-popup-header img')?.dataset.src || '';
				const titleEl = popup.querySelector('.wlfmc-popup-title');
				const descEl = popup.querySelector('.wlfmc-popup-desc');
				if (titleEl) {
					titleEl.innerHTML = title.replace(/{product_name}/g, productTitle).replace(/{product_price}/g, originalPrice);
				}
				if (descEl) {
					descEl.innerHTML = desc.replace(/{product_name}/g, productTitle).replace(/{product_price}/g, originalPrice);
				}
				const imgEl = popup.querySelector('.wlfmc-popup-header img');
				if (imgEl) imgEl.src = img;
			}
		}
	});
}

export function handleVariationHide(productId, moduleType, store, ui) {
	if (!productId) return;
	if (moduleType === 'waitlist') {
		const l10n = window.wlfmc_l10n || {};
		if (validators.isTrue(l10n.waitlist_required_product_variation)) {
			const targets = document.querySelectorAll(
				`.wlfmc-add-to-waitlist [data-parent-product-id="${productId}"]`
			);
			targets.forEach(t => {
				const container = t.closest('.wlfmc-add-to-waitlist');
				if (container) {
					const trigger = container.querySelector('.wlfmc-popup-trigger');
					if (trigger) trigger.classList.add('wlfmc-disabled');
				}
			});
		}
		return;
	}
	const prefix = moduleType === 'wishlist' ? 'wlfmc-add-to-wishlist' : 'wlfmc-add-to-waitlist';
	const targets = document.querySelectorAll(`.${prefix} [data-parent-product-id="${productId}"]`);
	targets.forEach(el => {
		const container = el.closest(`.${prefix}`);
		if (container) {
			container.classList.add('hide');
		}
	});
}
